import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Frontend gate for /admin/* — a UX nicety only. The real enforcement is
// server-side (require_superadmin on every /api/admin/* route); this just
// keeps non-superadmins from seeing the dashboard shell.
const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!currentUser || currentUser.role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
